// extracted by mini-css-extract-plugin
export default {"vendor":"Vendor_vendor__cqWji","vendor__section":"Vendor_vendor__section__QFX7W","vendor__section-title":"Vendor_vendor__section-title__Ek+4z"};